import { object, string } from 'yup';

import CardVal from 'card-validator';

export default object().shape({
  display_number: string()
    .min(16, 'Mínimo 16 digitos')
    .test(
      'number',
      'Número de cartão inválido',
      (value) => CardVal.number(value).isPotentiallyValid
    )
    .required('É necessário inserir um número'),
  expiration_date: string()
    .test(
      'number',
      'Data de vencimento inválida',
      (value) => CardVal.expirationDate(value).isValid
    )
    .required('O vencimento é obrigatório'),
  cvv: string()
    .test(
      'number',
      'Verifique o CVV digitado',

      (value) =>
        value.length > 3 ? CardVal.cvv(value, 4) : CardVal.cvv(value).isValid
    )
    .required('O CVV é obrigatório'),
  holder_name: string().required('O nome do titular é obrigatório'),
});
